import axiosClient from "./axiosClient";

export const listarGastosComunes = () => axiosClient.get("/gastos-comunes").then((r) => r.data);
export const upsertGastoComun = (data) => axiosClient.post("/gastos-comunes", data).then((r) => r.data);
export const eliminarGastoComun = (id) => axiosClient.delete(`/gastos-comunes/${id}`);
